export const setAuthToken = (data: any) => {
  localStorage.setItem("authInfo", data);
};
